import gql from 'graphql-tag';

export default gql`
    fragment EnquiryLead on Funeral {
        LeadSource {
            ID
            ChannelID
            ChannelOptionID
            SourceName
        }
    }
`;

export const Prearrangement = gql`
    fragment PrearrangementEnquiryLead on Prearrangement {
        LeadSource {
            ID
            ChannelID
            ChannelOptionID
            SourceName
        }
    }
`;
